import {difference, filter, isArray, isNumber, reduce} from "underscore";

const processAndCreateTags = async (tags = [], createTagMutation) => {
  const newTags = [];
  const existingTagIds = [];
  tags.forEach((tag) => {
    if (!tag?.id) {
      newTags.push(tag);
    } else {
      existingTagIds.push(tag.id);
    }
  });

  const newTagIds = await createTags(newTags, createTagMutation);

  const allIds = [...existingTagIds, ...newTagIds];
  const finalData = allIds.map((id) => ({tagId: id}));
  return finalData;
};

const diffTags = async (existingTags = [], finalTags, createTagMutation) => {
  const newTags = filter(finalTags, (tag) => !isNumber(tag?.id));
  const createdTagIDs = await createTags(newTags, createTagMutation);

  const existingTagIDs = [];
  existingTags.forEach((tag) => existingTagIDs.push(tag.tag.id));

  const finalExistingTags = filter(finalTags, (tag) => isNumber(tag?.id));
  const finalExistingTagIDs = [];
  const addedTagIDs = [];
  finalExistingTags.forEach((tag) => {
    if (tag?.id) {
      finalExistingTagIDs.push(tag.id);
    }
    if (tag?.tag?.id) {
      finalExistingTagIDs.push(tag.tag.id);
    }
    if (!existingTagIDs.includes(tag?.id)) {
      addedTagIDs.push(tag?.id);
    }
  });

  const removedTagIDs = difference(existingTagIDs, finalExistingTagIDs);
  const addedAndCreatedIDs = [...addedTagIDs, ...createdTagIDs];
  return {
    tagsToCreate: addedAndCreatedIDs.map((id) => ({tagId: id})),
    tagsToDelete: removedTagIDs,
  };
};

const createTags = async (newTags = [], createTag) => {
  const newTagIds = [];
  for (const tag of newTags) {
    const response = await createTag({variables: {tag: tag.value}});
    if (response?.data?.createOneTag?.id) {
      newTagIds.push(response.data.createOneTag.id);
    }
  }
  return newTagIds;
};

const tagTimesUsed = (tag) =>
  reduce(tag?.inUseBy || [], (count, usage) => count + usage.count, 0);

const extractTags = (tags) => {
  const existingTags = [];
  if (!isArray(tags)) {
    return existingTags;
  }
  for (const tag of tags) {
    existingTags.push(tag.tag);
  }
  return existingTags;
};

export {processAndCreateTags, diffTags, tagTimesUsed, extractTags};
